import type { ConversationSidePanelType } from "@app/types/conversation_side_panel";
import {
  INTERACTIVE_CONTENT_SIDE_PANEL_TYPE,
  NAVIGATEUR_SIDE_PANEL_TYPE,
} from "@app/types/conversation_side_panel";

export const DEFAULT_RIGHT_PANEL_SIZE = 40;
export const DEFAULT_FRAME_PANEL_SIZE = (2 / 3) * 100;
// Fork : largeur du panneau Navigateur de l'ancienne app (62 %), pour lire la page distante.
export const DEFAULT_NAVIGATEUR_PANEL_SIZE = 62;

export function getDefaultRightPanelSize(
  panelType: ConversationSidePanelType
): number {
  switch (panelType) {
    case INTERACTIVE_CONTENT_SIDE_PANEL_TYPE:
      return DEFAULT_FRAME_PANEL_SIZE;
    case NAVIGATEUR_SIDE_PANEL_TYPE:
      return DEFAULT_NAVIGATEUR_PANEL_SIZE;
    default:
      return DEFAULT_RIGHT_PANEL_SIZE;
  }
}
